const Logo = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <img 
        src="/lovable-uploads/f099ba0d-4461-42b2-9dc9-9b0ff4fc7716.png" 
        alt="Logo" 
        className="max-w-full max-h-screen object-contain"
      />
    </div>
  );
};

export default Logo;
